// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getLastChildOfTree = (obj: any): any => {
  return obj.firstChild && !obj.firstChild.length ? getLastChildOfTree(obj.firstChild) : obj;
};
